import React from 'react';
import PropTypes from 'prop-types';

const FormSteps = ({ children, activeIndex }) => React.Children.toArray(children)[activeIndex];

FormSteps.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  activeIndex: PropTypes.number,
};

export default FormSteps;
